import { RegimeTributarioDescription } from "@/features/contabil/@types/types";
import type {
  IEnquadramentoSimples,
  IGetDetalhesFormaTributacaoResponse
} from "../requests/types";
import { IDetalhesFormasTributacaoDataSource } from "@/features/contabil/dashboard/widgets/FormasTributacao/types";
import Empresa from "@/features/contabil/common/Empresa";
import EmpresaMapper from "@/features/contabil/common/EmpresaMapperAdapter";
export interface IFormaTributacaoHistorico {
  year: string;
  value: number;
}

export interface IFormaTributacao {
  empresa: Empresa;
  historico: IFormaTributacaoHistorico[] | null;
  enquadramentoSimples: {
    mensagem: string;
    periodoEnquadramento: {
      inicio: string;
      fim: string | null;
    }[];
  } | null;
}

export interface IDetalhesFormaTributacao {
  empresas: IFormaTributacao[];
}

export default class DetalhesFormaTributacao {
  constructor(
    readonly response: IGetDetalhesFormaTributacaoResponse | undefined
  ) {}

  private handleHistorico(
    historico: Record<string, number> | undefined
  ): IFormaTributacaoHistorico[] | null {
    if (!historico) return null;

    return Object.entries(historico).map(([key, value]) => ({
      value: value,
      year: key
    }));
  }

  toTable(): IDetalhesFormasTributacaoDataSource[] {
    return this.handler().map((tributacao) => ({
      empresa: tributacao.empresa,
      regime: tributacao.historico,
      enquadramentoSimples: tributacao.enquadramentoSimples,
      possuiEnquadramento: tributacao.enquadramentoSimples != null
    }));
  }

  getRegime(row: IDetalhesFormasTributacaoDataSource, year: number) {
    const empresa = this.toTable().find(
      (rowCompare) =>
        rowCompare.empresa.getCNPJ().mask() === row.empresa.getCNPJ().mask()
    );

    if (!empresa?.regime) return "Fila de processamento";

    const regime = empresa?.regime.find(
      (regime) => regime.year === year.toString()
    );

    if (!regime) return "";

    return RegimeTributarioDescription.get(regime.value);
  }

  handleEnquadramento(enquadramento: IEnquadramentoSimples | null) {
    if (!enquadramento) return null;

    return {
      mensagem: enquadramento.situacao || "-",
      periodoEnquadramento:
        enquadramento.enquadramentos.map((periodo) => ({
          inicio: periodo.dataInicial,
          fim: periodo.dataFinal
        })) || []
    };
  }

  handler(): IFormaTributacao[] {
    return (
      this.response?.empresas.map((empresa) => ({
        empresa: EmpresaMapper.toEntity(empresa),
        historico: this.handleHistorico(
          empresa.historicoRegimeTributario || undefined
        ),
        id: empresa.cnpj.completo || "-",
        enquadramentoSimples: this.handleEnquadramento(
          empresa.enquadramentoSimples
        )
      })) || []
    );
  }
}
